// extracted by mini-css-extract-plugin
export var banner = "_sx-0";
export var settingRow = "_sx-2";
export var titleIcon = "_sx-1";